import { MessageSquareWarning } from "lucide-react";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { useFeedbackStore } from "@/store/feedback.store";

interface Props {
  visitPublicId: string;
  className?: string;
}

// A quiet line under a visit document: "Something off with this note?
// Tell us" opens feedback as "Note quality" with this visit's id offered.
export const NoteFeedbackPrompt = ({
  visitPublicId,
  className,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <p
      className={cn(
        "flex flex-wrap items-center gap-x-1.5 text-sm text-muted-foreground",
        className,
      )}
      data-testid="note-feedback-prompt"
    >
      <MessageSquareWarning aria-hidden className="size-4 shrink-0" />
      <span>{t("feedback.inApp.notePrompt")}</span>
      <button
        className="relative rounded-sm font-semibold text-primary underline-offset-2 after:absolute after:-inset-x-1.5 after:-inset-y-3 after:content-[''] hover:underline focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring"
        data-testid="note-feedback-open"
        type="button"
        onClick={() => {
          useFeedbackStore
            .getState()
            .show({ visitPublicId, type: "note_quality" });
        }}
      >
        {t("feedback.inApp.notePromptAction")}
      </button>
    </p>
  );
};
